import * as React from "react";
import whyDidYouRender from "@welldone-software/why-did-you-render";

// window.localStorage.setItem("enable_wdyr", "true")
const ENABLED = window.localStorage.getItem("enable_wdyr");

if (process.env.NODE_ENV === "development") {
  if (ENABLED) {
    // biome-ignore lint: Development debug statement for WDYR initialization
    console.log("wdyr");
    whyDidYouRender(React, {
      trackAllPureComponents: true,
      exclude: [/Unknown/, /EdgeRenderer/, /FlowRenderer/, /Pane/],
    });
  }
}
